export function desktopThumbnailCacheKey(userId: string | null, clientId: string, filePath: string): string | null {
  return userId ? JSON.stringify(['desktop', userId, clientId, filePath]) : null;
}

export function createTaskQueue(limit: number) {
  if (!Number.isInteger(limit) || limit < 1) throw new RangeError('Task queue limit must be positive');
  let active = 0;
  const waiting: Array<() => void> = [];

  return {
    run<T>(task: () => Promise<T>): Promise<T> {
      return new Promise<T>((resolve, reject) => {
        const start = () => {
          active++;
          Promise.resolve().then(task).then(resolve, reject).finally(() => {
            active--;
            waiting.shift()?.();
          });
        };
        if (active < limit) start();
        else waiting.push(start);
      });
    },
  };
}

export function createLatestRequestGuard() {
  let version = 0;
  return {
    next: () => ++version,
    current: () => version,
    invalidate: () => { version++; },
    isCurrent: (requestVersion: number) => requestVersion === version,
  };
}
